import type { Messages } from '../de';

export default {
  nav: {
    today: 'Today',
    activities: 'Activities',
    analysis: 'Analysis',
    health: 'Health',
    goals: 'Goals & records',
    planning: 'Planning',
    season: 'Season',
    maps: 'Maps',
    wrapped: 'Wrapped',
    settings: 'Settings',
  },
  tab: { goals: 'Goals', more: 'More' },
  mainNav: 'Main navigation',
  account: 'Account',
  lastSynced: 'Last synced',
  syncRunning: 'Running …',
  syncNow: 'Sync now',
  syncNever: 'never',
  syncFailed: 'failed {ago}',
  authOidc: 'via login service',
  authProxy: 'via proxy',
  authDev: 'local, no sign-in',
  pageLoading: 'Loading page …',
  notFound: 'Page not found',
  notFoundText: 'This address does not exist in dashy-dash – perhaps an old link.',
  notFoundBack: 'Go to Today',
} satisfies Messages['shell'];
